if (!customElements.get('ss-auausave-event')) {
  customElements.define('ss-auausave-event', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.buttons = [...this.querySelectorAll('[data-bundle]')];
      this.result = this.querySelector('.ss-auau-result');
      this.status = this.querySelector('[data-status]');
      this.buttons.forEach(button => button.addEventListener('click', () => this.addBundle(button)));
      document.title = `${this.dataset.title} | SKIN SYRUP`;
      // Keep this preview-only view when the native language form redirects.
      document.querySelectorAll('form[action*="localization"] [name="return_to"]').forEach(input => {
        input.value = window.location.pathname + window.location.search;
      });
    }

    async addBundle(button) {
      if (this.busy || button.disabled) return;
      this.busy = true;
      const availableButtons = this.buttons.filter(item => !item.disabled);
      const label = button.querySelector('[data-label]');
      const originalLabel = label.textContent;
      availableButtons.forEach(item => { item.disabled = true; });
      label.textContent = this.dataset.busy;
      button.setAttribute('aria-busy', 'true');
      this.result.hidden = true;
      this.result.classList.remove('is-error');
      let added = false;
      try {
        const items = JSON.parse(button.dataset.items);
        if (items.length !== 2 || items.some(item => !Number.isSafeInteger(item.id) || !Number.isSafeInteger(item.quantity) || item.quantity < 1)) {
          throw new Error(this.dataset.error);
        }
        const drawer = document.querySelector('cart-drawer');
        const sections = drawer ? drawer.getSectionsToRender().map(section => section.id) : ['cart-icon-bubble'];
        const response = await fetch(window.routes?.cart_add_url || `${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items, sections, sections_url: window.location.pathname })
        });
        const data = await response.json();
        if (!response.ok || data.status) {
          throw new Error(typeof data.description === 'string' ? data.description : this.dataset.error);
        }
        if (!Array.isArray(data.items) || data.items.length !== 2) throw new Error(this.dataset.error);
        added = true;
        this.status.textContent = this.dataset.success;
        this.result.hidden = false;
        // A notification shows one product only; update its cart count without hiding the second item.
        if (drawer && data.sections?.['cart-drawer']) {
          drawer.setActiveElement(button);
          drawer.classList.remove('is-empty');
          drawer.renderContents(data);
        } else if (data.sections?.['cart-icon-bubble']) {
          const markup = new DOMParser().parseFromString(data.sections['cart-icon-bubble'], 'text/html');
          const content = markup.querySelector('.shopify-section');
          const bubble = document.getElementById('cart-icon-bubble');
          if (content && bubble) bubble.innerHTML = content.innerHTML;
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ss-auausave-event', cartData: data });
        }
      } catch (error) {
        if (!added) {
          this.status.textContent = error instanceof TypeError ? this.dataset.error : error.message || this.dataset.error;
          this.result.classList.add('is-error');
        }
        this.result.hidden = false;
      } finally {
        availableButtons.forEach(item => { item.disabled = false; });
        label.textContent = originalLabel;
        button.removeAttribute('aria-busy');
        this.busy = false;
      }
    }
  });
}
